export default __webpack_public_path__ + "img/236d9a191ebabcc008c341a63c3acff4.svg";